import React from 'react';

import './Keyword.styles.css'

const Keyword = ({val}) => {
    return (
        <div className='keyword'>
            {val}
        </div>
    )
}

export default Keyword;
